import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LanguageService } from 'src/app/core/services/language.service';
import { RootReducerState } from 'src/app/modals';
import { getUser } from 'src/app/modals/Authentication/authentication-selector';

@Component({
  selector: 'extra-pages-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule], 
  templateUrl: './extra-pages.component.html',
  styleUrl: './extra-pages.component.css'
})

export class extraPagesComponent implements OnInit, OnDestroy {

  today: Date = new Date();
  year: number = new Date().getFullYear();
  user$: Observable<any>;
  private destroy$ = new Subject<void>();

  constructor(
    public languageService: LanguageService,
    public store: Store<RootReducerState>,
  ) {}

  ngOnInit(): void {
    this.store.select(getUser)
                .pipe(takeUntil(this.destroy$))
                .subscribe((getUser) => {
                  //Change made in user
                  if(getUser){
                    //User has been updated, It does not get triggered when the request fails
                    this.languageService.checkAndSet(getUser.lang)
                  }
                });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
